import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

import connectEditElementToBriefStore from 'contest/components/connected/connect-edit-element-to-brief-store';
import { connectReadElement } from 'contest/components/brief/read-element';

const ReadChoiceOtherElement = ({ text }) => <p>{text}</p>;
ReadChoiceOtherElement.propTypes = { text: PropTypes.string.isRequired };

export const ViewChoiceOtherElement = connectReadElement(
    ReadChoiceOtherElement,
    element => {
        if (element.value.hasOwnProperty('other')) {
            return { text: element.value.other };
        } else if (element.value.choice && element.trans.hasOwnProperty('viewChoices')) {
            return { text: element.trans.viewChoices[element.value.choice] };
        } else if (element.value.choice) {
            return { text: element.trans.choices[element.value.choice] };
        } else {
            return { text: '' };
        }
    },
    ({ value }) => value.other != null || value.choice != null
);

export const ViewChoiceElement = connectReadElement(ReadChoiceOtherElement, element => {
    if (element.trans.hasOwnProperty('viewChoices')) {
        return { text: element.trans.viewChoices[element.value] };
    } else {
        return { text: element.trans.choices[element.value] };
    }
});

export class EditChoiceOtherElement extends Component {
    constructor(props) {
        super(props);

        this.handleChoiceChange = this.handleChoiceChange.bind(this);
        this.handleOtherChange = this.handleOtherChange.bind(this);

        const hasChoice = props.value.hasOwnProperty('choice');
        this.state = {
            choice: hasChoice ? props.value.choice : props.otherKey,
        };
    }

    handleChoiceChange(event) {
        this.setState(
            {
                choice: event.target.value,
            },
            () => {
                if (!this.isOtherSelected()) {
                    let value = this.state.choice;
                    if (value == '') {
                        value = null;
                    }
                    this.props.onChange(
                        {
                            choice: value,
                        },
                        true
                    );
                }
            }
        );
    }

    handleOtherChange(event) {
        this.props.onChange(
            {
                other: event.target.value,
            },
            false
        );
    }

    isOtherSelected() {
        return this.props.hasOther && this.state.choice == this.props.otherKey;
    }

    render() {
        return (
            <div className="field">
                <div className="field__input">
                    <span className="select select--full-width">
                        <select value={this.state.choice || ''} onChange={this.handleChoiceChange}>
                            {this.renderOptions()}
                        </select>
                    </span>
                </div>
                {this.props.hasOther && this.renderOther()}
            </div>
        );
    }

    renderOptions() {
        const { choices, allowEmpty, emptyOption, hasOther, otherKey, otherOption } = this.props;

        let options = Object.keys(choices).map(key => (
            <option key={key} value={key}>
                {choices[key]}
            </option>
        ));

        if (hasOther) {
            options = [
                ...options,
                <option key={otherKey} value={otherKey}>
                    {otherOption ||
                        this.props.intl.formatMessage({ id: 'brief_choice_other_option' })}
                </option>,
            ];
        }

        if (allowEmpty) {
            options = [
                <option key="" value="">
                    {emptyOption}
                </option>,
                ...options,
            ];
        }
        return options;
    }

    renderOther() {
        if (this.isOtherSelected()) {
            return (
                <div className="field__input">
                    <input
                        type="text"
                        className="input-text input-width--max"
                        defaultValue={this.props.value.other}
                        placeholder={this.props.otherPlaceholder}
                        onChange={this.handleOtherChange}
                        onBlur={this.props.onSave}
                        autoFocus={true}
                    />
                </div>
            );
        }
    }
}
EditChoiceOtherElement.propTypes = {
    value: PropTypes.object.isRequired,
    choices: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    otherKey: PropTypes.string,
    otherPlaceholder: PropTypes.string,
    allowEmpty: PropTypes.bool,
    emptyOption: PropTypes.string,
    otherOption: PropTypes.string,
    hasOther: PropTypes.bool,
};
EditChoiceOtherElement.defaultProps = {
    onChange: () => {},
    onSave: () => {},
    otherKey: '__other__',
    otherPlaceholder: '',
    allowEmpty: true,
    emptyOption: '',
    otherOption: '',
    hasOther: false,
};

const EditChoiceOtherElementWithIntl = injectIntl(EditChoiceOtherElement);

export const ConnectedEditChoiceOtherElement = connectEditElementToBriefStore(
    EditChoiceOtherElementWithIntl,
    element => ({
        value: element.value,
        choices: element.trans.choices,
        hasOther: true,
        otherPlaceholder: element.trans.otherPlaceholder,
        allowEmpty: element.trans.hasOwnProperty('emptyOption'),
        emptyOption: element.trans.emptyOption,
        otherOption: element.trans.otherOption,
    }),
    value => value
);

export const ConnectedEditChoiceElement = connectEditElementToBriefStore(
    EditChoiceOtherElementWithIntl,
    element => ({
        value: {
            choice: element.value,
            other: null,
        },
        choices: element.trans.choices,
        allowEmpty: element.trans.hasOwnProperty('emptyOption'),
        emptyOption: element.trans.emptyOption,
        hasOther: false,
    }),
    ({ choice }) => choice
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/choice-other-element.jsx